import { render, staticRenderFns } from "./CardCom342.vue?vue&type=template&id=37b0be8a&"
import script from "./CardCom342.vue?vue&type=script&lang=js&"
export * from "./CardCom342.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports